import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const PAGE_LABELS = {
  '/dashboard/catalogue': 'Shop',
  '/dashboard/cart': 'Cart',
  '/dashboard/starter-packs': 'Starter Packs',
  '/dashboard/my-salon-orders': 'My Orders',
  '/dashboard/my-salon-invoices': 'Invoices',
  '/dashboard/my-salon-quotes': 'My Quotes',
  '/dashboard/training-module': 'Training',
  '/dashboard/education': 'Education Hub',
  '/dashboard/protocols': 'Protocols',
  '/dashboard/lookbook': 'Lookbook',
  '/dashboard/results-logbook': 'Results',
  '/dashboard/business-planner': 'Business Planner',
  '/dashboard/calculator': 'Calculator',
  '/dashboard/rewards': 'Partner Rewards',
  '/dashboard/salon-directory': 'Professionals',
  '/dashboard/product-scanner': 'Scan & Reorder',
  '/dashboard/subscriptions': 'Auto-Restock',
  '/dashboard/reorder': 'Reorder',
  '/dashboard/reorder-intelligence': 'Smart Restock',
  '/dashboard/profile': 'My Profile',
  '/dashboard/messages': 'Notifications',
  '/dashboard/faq': 'FAQ',
  '/dashboard/help': 'Help & Support',
  '/dashboard/orders': 'Orders',
  '/dashboard/quotes': 'Quotes & Orders',
  '/dashboard/uk-invoices': 'UK Invoices',
  '/dashboard/inventory': 'Inventory',
  '/dashboard/sales-log': 'Sales Log',
  '/dashboard/ceo-command': 'CEO Command',
  '/dashboard/salon-search': 'Clients & Salons',
  '/dashboard/uk-orders': 'UK Orders',
  '/dashboard/uk-dispatch': 'UK Dispatch',
  '/dashboard/salon-settings': 'Salon Settings',
  '/dashboard/security': 'Security',
  '/dashboard/quick-order': 'Quick Order',
  '/dashboard/sales-analytics': 'Sales Analytics',
  '/dashboard/uk-warehouse': 'UK Warehouse',
  '/dashboard/salon-performance': 'Salon Performance',
  '/dashboard/ceo-digest': 'CEO Digest',
  '/dashboard/staff': 'Staff Directory',
  '/dashboard/salon-registry': 'My Clients',
};

export function usePageVisitTracker() {
  const location = useLocation();
  const { token } = useAuth();
  const prevPath = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === '/dashboard' || path === prevPath.current || !token) return;
    prevPath.current = path;

    const label = PAGE_LABELS[path];
    if (!label) return;

    fetch(`${API}/api/page-visits/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ path, label }),
    }).catch(() => {});
  }, [location.pathname, token]);
}
